import { colorsPrimitive as colors } from "./colorsPrimitive";

export const colorsForeground = {
	fg_primary: colors.primary.grayLight[900],
	fg_primary_dark: colors.primary.base["white"],

	fg_secondary: colors.primary.grayLight[700],
	fg_secondary_dark: colors.primary.grayDark[300],
	fg_secondary_hover: colors.primary.grayLight[800],
	fg_secondary_hover_dark: colors.primary.grayDark[200],

	fg_tertiary: colors.primary.grayLight[600],
	fg_tertiary_dark: colors.primary.grayDark[400],
	fg_tertiary_hover: colors.primary.grayLight[700],
	fg_tertiary_hover_dark: colors.primary.grayDark[300],

	fg_quaternary: colors.primary.grayLight[400],
	fg_quaternary_dark: colors.primary.grayDark[600],
	fg_quaternary_hover: colors.primary.grayLight[500],
	fg_quaternary_hover_dark: colors.primary.grayDark[500],

	fg_white: colors.primary.base["white"],

	fg_disabled: colors.primary.grayLight[400],
	fg_disabled_dark: colors.primary.grayDark[500],
	fg_disabled_subtle: colors.primary.grayLight[300],
	fg_disabled_subtle_dark: colors.primary.grayDark[600],

	fg_brand_primary: colors.primary.brand[600],
	fg_brand_primary_dark: colors.primary.brand[500],
	fg_brand_primary_alt: colors.primary.brand[600],
	fg_brand_primary_alt_dark: colors.primary.grayDark[300],

	fg_brand_secondary: colors.primary.brand[500],
	fg_brand_secondary_dark: colors.primary.brand[500],
	fg_brand_secondary_alt: colors.primary.brand[500],
	fg_brand_secondary_alt_dark: colors.primary.grayDark[600],

	fg_error_primary: colors.primary.error[600],
	fg_error_primary_dark: colors.primary.error[500],
	fg_error_secondary: colors.primary.error[500],
	fg_error_secondary_dark: colors.primary.error[400],

	fg_warning_primary: colors.primary.warning[600],
	fg_warning_primary_dark: colors.primary.warning[500],
	fg_warning_secondary: colors.primary.warning[500],
	fg_warning_secondary_dark: colors.primary.warning[400],

	fg_success_primary: colors.primary.success[600],
	fg_success_primary_dark: colors.primary.success[500],
	fg_success_secondary: colors.primary.success[500],
	fg_success_secondary_dark: colors.primary.success[400],
};
